<template>
  <v-row
    class="patient-list-controls elevation-0 escalon-bb align-center secondary"
    :style="'border-bottom-color: ' + colorHex + ' !important'">
    <select-with-button
      selection-prefix="VIEW:"
      :value="searchTimespan"
      :items="timespanOptions"
      @input="submitTimespanSearch"
      button-slot="prepend"
      label="Select Time Span"
      class="toolbar-select"
      :class="colorClass"
      v-if="!ssoEmrPro"/>
    <v-btn text
      @click="$emit('newPatient')" 
      v-if="!ssoEmrPro && !userIsViewOnly && !userIsReadOnly" 
      style="padding-left: 0px">
      <v-avatar size="30" class="mr-1">
        <img :src="newPatientIcon" />
      </v-avatar>New Patient
    </v-btn>
  </v-row>
</template>

<script>
import selectWithButton from "../controls/SelectWithButton";
import { PATIENT_DATE_SETTING } from "../../config/config";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "PatientListToolbar",
  components: { selectWithButton },
  data() {
    return { timespanOptions: PATIENT_DATE_SETTING };
  },
  computed: {
    ...mapGetters(["searchTimespan", "ssoEmrPro", "userIsViewOnly", "userIsReadOnly"]),
    newPatientIcon() {
      return require("../../assets/" + this.coloredAssetUrls.addPatient);
    }
  },
  methods: {
    ...mapActions(["submitTimespanSearch"])
  }
};
</script>